<template>
  <div class="page-discuss">
    <div class="wrap">
      <h1>{{proName}}</h1>
      <div class="content">
        <ul id="scrollList">
          <li
            class="tc m-btn mb-20"
            @click="getMore"
            v-if="listData && listData.length"
          >{{hasTotal ? '没有更多了' : '查看更多'}}</li>
          <li class="clearfix" v-for="(item, index) in listData" :key="index">
            <!-- 非自己 -->
            <div class="item item-other fl clearfix" v-if="!item.selfSend">
              <img class="fl" :src="item.userImg||''" alt :onerror="defaultHeadImg">
              <div class="para-box">
                <p class="m-assist">{{item.sender}}</p>
                <p class="para images" v-viewer v-html="item.messageContent"></p>
                <p class="mes-time m-tit mt-10">{{item.sendTimeStr}}</p>
              </div>
            </div>

            <!-- 自己 -->
            <div class="item item-myself fr clearfix" v-if="item.selfSend">
              <div class="para-box">
                <p class="para images" v-viewer v-html="item.messageContent"></p>
                <p class="mes-time m-tit fr mt-10">{{item.sendTimeStr}}</p>
              </div>
              <img class="fr" :src="$store.state.user.headImg || ''" alt :onerror="defaultHeadImg">
            </div>
          </li>
        </ul>

        <!-- 发表讨论 -->
        <div class="bottom">
          <div class="editor-container">
            <img
              class="g-pic mr-10"
              :src="$store.state.user.headImg || ''"
              alt
              :onerror="defaultHeadImg"
            >

            <div class="editor-con">
              <el-input v-model="msg" placeholder="点击发表讨论" v-if="!isEdit" @focus="isEdit=true"></el-input>
              <cmp-ckeditor ref="myCkeditor" :id="`ue1`" :height="150"></cmp-ckeditor>
              <!-- <UE :defaultMsg="msg" :config="config" :id="ue1" :keydownCall="chat" ref="ue" v-if="isEdit"></UE> -->
            </div>

            <!-- 操作 -->
            <div class="operate">
              <el-button class="btn-comment" type="primary" @click="chat">发送</el-button>
              <!-- <el-button class="btn-comment" type="" @click="isEdit=false">取消</el-button> -->
            </div>
          </div>

          <!-- 操作 -->
          <!-- <div class="operate mt-10">
            <el-button class="btn-comment" type="primary" @click="chat">发送</el-button>
          </div>-->
        </div>
      </div>
    </div>
    <!-- <cmp-footer class="relat"></cmp-footer> -->
  </div>
</template>

<script>
// https://github.com/mirari/v-viewer
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)
import io from 'socket.io-client'
// import cmpFooter from '@cmp/footer'
// import UE from '@cmp/ue/ue.vue'
import cmpCkeditor from '@cmp/editor/ckeditor.vue'
export default {
  components: {
    // cmpFooter,
    // UE,
    cmpCkeditor
  },
  data() {
    console.log('****', process.env.VUE_APP_SOCKET_URL)
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,

      socket: io.connect(
        process.env.VUE_APP_SOCKET_URL +
          '?projectId=' +
          this.$route.query.projectId +
          '&userId=' +
          this.$store.state.user.userid
      ), // 部署
      // socket: io.connect(http://dev.tj720.com:8081?projectId='+this.$route.query.projectId+'&userId='+this.$store.state.user.userid),
      proName: this.$route.query.projectName,
      listData: [],
      msg: '',
      currentPage: 1,
      size: 30,
      form: {
        info: '',
        subDate: '' // 子任务时间
      },
      isMore: false, // 是否为向上加载操作
      hasTotal: false, // 是否展示全部
      isEdit: true,
      config: {
        // initialContent: 'Ctrl+Enter快速发布',//初始化编辑器的内容
        // autoClearinitialContent: true,
        enableAutoSave: false, // 关闭自动保存
        elementPathEnabled: false, // 是否启用元素路径，默认是显示
        wordCount: false, // 是否开启字数统计
        toolbars: [
          [
            'source',
            'emotion',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'formatmatch',
            'blockquote',
            'forecolor',
            '|',
            'insertorderedlist',
            'insertunorderedlist',
            'indent',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            'touppercase',
            'tolowercase',
            '|',
            'link',
            'simpleupload',
            'insertimage'
          ]
        ],
        initialFrameWidth: null,
        initialFrameHeight: 100
      },
      ue1: 'ue1' // 不同编辑器必须不同的id
    }
  },
  methods: {
    // 评论
    chat() {
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      console.log(content)
      if (!content) {
        this.$message.info('请输入内容')
        return
      }
      this.socket.emit('messageevent', {
        projectId: this.$route.query.projectId,
        userId: this.$store.state.user.userid,
        messageType: 'chat',
        messageContent: content
      })
      this.msg = ''
      this.$refs.myCkeditor.setContent('') // 调用子组件方法
    },
    getDataList(type) {
      if (type === 'changePro') {
        this.proName = this.$route.query.projectName
        this.handleChangePro()
        return
      }
      console.log('getDatalist', this.$route.query.projectId)
      this.socket.emit('getMessageWithPage', {
        projectId: this.$route.query.projectId,
        userId: this.$store.state.user.userid,
        messageType: 'chat',
        startTime: '',
        endTime: '',
        currentPage: this.currentPage,
        size: this.size
      })
    },
    getMore() {
      if (this.hasTotal) return
      this.isMore = true
      this.currentPage += 1
      this.getDataList()
    },
    handleChangePro() {
      this.socket.disconnect() // 断开连接

      this.listData = []

      this.socket = io.connect(
        process.env.VUE_APP_SOCKET_URL +
          '?projectId=' +
          this.$route.query.projectId +
          '&userId=' +
          this.$store.state.user.userid
      )

      this.eventListen()
    },
    eventListen() {
      this.socket.on('connect', () => {
        console.log('连接成功')

        this.getDataList()
      })

      this.socket.on('connectTimeOut', value => {
        if (value) {
          // 重新登录
          this.$alert('', '登录超时，请重新登录', {
            confirmButtonText: '确定',
            callback: () => {
              this.$store.dispatch('LoginOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            }
          })
        }
      })

      this.socket.on('getMessageWithPage', value => {
        this.$nextTick(() => {
          console.log('分页数据', value)
          if (value.length < this.size) {
            this.hasTotal = true
          }
          this.listData = value.concat(this.listData)
        })
      })

      this.socket.on('messageevent', value => {
        this.isMore = false
        console.log('数据', this.listData)
        this.listData = this.listData.concat(value)
      })

      this.socket.on('connect_error', error => {
        console.log('error', error)
      })

      this.socket.on('disconnect', () => {
        console.log('断开连接成功')
      })
    }
  },
  created() {},
  mounted() {
    this.$store.state.user.noScrollY = true
    this.eventListen()

    this.$nextTick(() => {
      this.$refs.myCkeditor.initEditor()
    })
  },
  //每次页面渲染完之后滚动条在最底部
  updated() {
    this.$nextTick(() => {
      if (this.isMore) return
      var div = document.getElementById('scrollList')
      div.scrollTop = div.scrollHeight
    })
  },
  beforeDestroy() {
    this.socket.disconnect() // 断开连接
    this.$store.state.user.noScrollY = false
  }
}
</script>

<style lang="scss" scoped>
.page-discuss {
  margin: 0 auto;
  width: 1200px;
  padding: 30px 0;
  word-break: break-all;
  .wrap {
    // min-height: calc( 100vh - 190px);
    // height: calc( 100vh - 190px);
    // height: calc( 100vh - 280px);
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    border-radius: 4px;
    h1 {
      margin-bottom: 0;
      padding-bottom: 20px;
      border-bottom: solid 1px $border;
    }
    .content {
      padding-top: 20px;
      ul {
        height: calc(100vh - 510px);
        overflow-y: auto;
        overflow-x: hidden;
      }
      .item {
        margin-bottom: 30px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 100%;
        }
        .para-box {
          position: relative;
          padding-bottom: 30px;
          .m-assist {
            margin-bottom: 10px;
          }
          .para {
            position: relative;
            padding: 10px;
            max-width: 660px;
            box-sizing: border-box;
            color: #575962;
            border-radius: 5px;
            /deep/ img {
              max-width: 100%;
              max-height: 300px;
              object-fit: cover;
            }
          }
          .mes-time {
            position: absolute;
            bottom: 0;
            width: 200px;
          }
        }
      }
      .item-other {
        img {
          // margin-top: 5px;
        }
        .para-box {
          padding-left: 50px;
          .para {
            background: #ebedf2;
            &:after {
              content: '';
              display: block;
              @include bg(url('~@images/triangle-l.svg'), 8px, 28px);
              position: absolute;
              left: -6px;
              top: 0;
            }
          }
          .mes-time {
            left: 58px;
          }
        }
      }
      .item-myself {
        padding-right: 10px;
        .para-box {
          position: relative;
          float: left;
          padding-left: 0;
          padding-right: 10px;
          .para {
            color: #fff;
            background: $primary;
          }
          .mes-time {
            right: -48px;
            padding-right: 70px;
            text-align: right;
          }
          &:after {
            content: '';
            display: inline-block;
            @include bg(url('~@images/triangle-r.svg'), 8px, 28px);
            position: absolute;
            right: 4px;
            top: 0;
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 30px;
    padding-top: 30px;
    border-top: solid 1px $border;
    .editor-container {
      display: flex;
      .editor-con {
        flex: 1;
      }
    }
    .operate {
      padding-left: 30px;
    }
  }
}
</style>


